import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ContactRoutingModule } from './contact-routing.module';
import { ContactComponent } from './contact/contact.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material';
import { ContactListComponent } from './contact-list/contact-list.component';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TableModule } from 'primeng/table';
import { ContactViewComponent } from './contact-view/contact-view.component';
import { ContactTabComponent } from './contact-tab/contact-tab.component';
import { ContactPanelComponent } from './contact-panel/contact-panel.component';
import { ContactEditComponent } from './contact-edit/contact-edit.component';
import { FormFieldComponent } from '../shared/form-field/form-field.component';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { ToastModule } from 'primeng/toast';
import { MatListModule } from '@angular/material/list';
import { InputTextModule } from 'primeng/inputtext';

@NgModule({
  declarations: [ContactComponent, ContactListComponent, ContactViewComponent, ContactTabComponent, ContactPanelComponent, ContactEditComponent, FormFieldComponent],
  imports: [
    CommonModule,
    ContactRoutingModule,
    MatFormFieldModule,	
    MatInputModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    ToastModule,
	FormsModule,
	MatCardModule,
	MatTabsModule,
	MatIconModule,
	MatButtonModule,
	MatCheckboxModule,	
	TableModule,   
  MessagesModule,
  MessageModule,
  MatListModule,
  InputTextModule
  ]
})
export class ContactModule { }
